import { useEffect, useState } from "react";
import {
  buildColumnsWithHeaderFilters,
  HeaderTable,
  PermissionDirect,
  TableActionButtons,
} from "../../Components";
import { decorateEditableColumns } from "../../shared/helpers/editableColumns";
import { useRequestLock } from "../../shared/hooks/useRequestLock";
import { hasNullRequiredField } from "../../shared/helpers/objectPath";
import { updateColumnDisplayState } from "../../shared/helpers/tableColumns";
import { TruckVendorApi } from "../../services";
import { PlusIcon, Setting } from "../../assets/icon";
import styles from "./Contructor.module.scss";
import {
  Checkbox,
  Button,
  Col,
  Divider,
  message,
  Modal,
  Pagination,
  Row,
  Table,
} from "antd";
import { checkPermissions } from "../../utils/checkPermissions";
import { useRecoilValue } from "recoil";
import { UserAtom } from "../../store";
import {
  DeleteOutlined,
  EditFilled,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { parseVehicleListTags } from "./helpers";
// import {
//   DEFAULT_SETTLE_AGREEMENT,
//   settleAgreementOptions,
// } from "../../shared/constants/settleAgreement";
const { confirm } = Modal;
const Contructor = () => {
  // Define constant
  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const permissionState = useRecoilValue<any>(UserAtom.permissions);
  const features = permissionState?.features;
  const newObj = {
    _id: null,
    code: null,
    // settleAgreement: DEFAULT_SETTLE_AGREEMENT,
  };
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const REQUIRED_FIELDS = [
    "code",
    "name",
    "shortName",
    "address",
    "taxNumber",
  ];
  const [dataSource, setDataSource] = useState<any>([]);
  const [filters, setFilters] = useState<any>({});
  const [onModalPostion, setOnModalPosition] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const { isLocked, runLocked } = useRequestLock();
  const [editIndex, setEditIndex] = useState<any>([]);
  const colBase = [
    {
      title: "#",
      dataIndex: "_id",
      width: 50,
      fixed: "left",
      hidden: true,
      render: (row: any, record: any, index: number) => index + 1,
    },
    {
      title: "Mã nhà xe",
      dataIndex: "code",
      // filterDataIndex: "searchText",
      fixed: false,
      hidden: false,
      editType: "Input",
      editProps: {
        style: { width: "unset" },
      },
      filterConfig: {
        type: "string",
        filterProps: {
          placeholder: "Nhập mã nhà xe",
        },
      },
    },
    {
      title: "Tên nhà xe",
      dataIndex: "name",
      filterDataIndex: "searchText",
      fixed: false,
      hidden: false,
      editType: "Input",
      filterConfig: {
        type: "string",
        filterProps: {
          placeholder: "Nhập tên nhà xe",
        },
      },
      colReturn: (row: any, record: any) => <div title={row}>{row}</div>,
    },
    {
      title: "Tên viết tắt",
      dataIndex: "shortName",
      fixed: false,
      hidden: false,
      editType: "Input",
      // filterConfig: {
      //   type: "string",
      //   filterProps: {
      //     placeholder: "Nhập tên viết tắt",
      //   },
      // },
    },
    {
      title: "Địa chỉ",
      dataIndex: "address",
      fixed: false,
      hidden: false,
      editType: "Input",
      // filterConfig: {
      //   type: "string",
      //   filterProps: {
      //     placeholder: "Nhập tên viết tắt",
      //   },
      // },
    },
    {
      title: "Số điện thoại",
      dataIndex: "phoneNumber",
      fixed: false,
      hidden: false,
      editType: "Input",
      // filterConfig: {
      //   type: "string",
      //   filterProps: {
      //     placeholder: "Nhập số điện thoại",
      //   },
      // },
    },
    {
      title: "Hotline",
      dataIndex: "hotline",
      fixed: false,
      hidden: false,
      editType: "Input",
      // filterConfig: {
      //   type: "string",
      //   filterProps: {
      //     placeholder: "Nhập số hotline",
      //   },
      // },
    },
    {
      title: "Mã số thuế",
      dataIndex: "taxNumber",
      fixed: false,
      hidden: false,
      editType: "Input",
      // filterConfig: {
      //   type: "string",
      //   filterProps: {
      //     placeholder: "Nhập số hotline",
      //   },
      // },
    },
    // {
    //   title: "Thời hạn thanh toán",
    //   dataIndex: "settleAgreement",
    //   fixed: false,
    //   hidden: false,
    //   editType: "SelectOption",
    //   editProps: {
    //     allowClear: true,
    //     placeholder: "Thời hạn thanh toán",
    //     options: settleAgreementOptions,
    //   },
    //   colReturn: (row: any) => row || DEFAULT_SETTLE_AGREEMENT,
    // },
    {
      title: "Số lượng xe",
      dataIndex: "vehicleList",
      fixed: false,
      hidden: false,
      editType: "SelectOption",
      editProps: (row: any, record: any) => {
        return {
          mode: "tags",
          tokenSeparators: ["\n", "\r\n", "\t", ",", ";", " "],
          style: {
            width: 250,
          },
          disabled: record.truckVendorType === "OWNER",
        };
      },
      colReturn: (row: any) => row?.length ?? 0,
    },
    // {
    //   title: "Chi phí uỷ thác",
    //   dataIndex: "cost",
    //   fixed: false,
    //   hidden: false,
    //   editType: "InputNumber",
    // },
    {
      title: "Tình trạng",
      dataIndex: "state",
      fixed: false,
      hidden: false,
      editType: "SelectOption",
      editProps: {
        options: [
          { label: "Đang hoạt động", value: "ACTIVE" },
          { label: "Ngưng hoạt động", value: "CLOSED" },
        ],
      },
      filterConfig: {
        type: "select",
        filterProps: {
          placeholder: "Chọn tình trạng",
          options: [
            { label: "Đang hoạt động", value: "ACTIVE" },
            { label: "Ngưng hoạt động", value: "CLOSED" },
          ],
        },
      },
      colReturn: (row: any, record: any) => (
        <div
          style={{
            color: row === "ACTIVE" ? "#0082FB" : "#F63535",
            fontWeight: "bold",
          }}
        >
          {row === "ACTIVE" ? "Đang hoạt động" : "Ngừng hoạt động"}
        </div>
      ),
    },
    // {
    //   title: "Nhận uỷ thác",
    //   dataIndex: "nhan_uy_thac",
    //   fixed: false,
    //   hidden: false,
    //   editType: "SwitchToggle",
    // },
    // {
    //   title: "Tác vụ",
    //   dataIndex: "nhan_uy_thac",
    //   fixed: false,
    //   hidden: false,
    //   editType: "SwitchToggle",
    // },
  ];
  const [columns, setColumns] = useState(colBase);
  const handleSetFilters = (nextFilters: any) => {
    setPagination((prev) => ({ ...prev, current: 1 }));
    setFilters((prevFilters: any) =>
      typeof nextFilters === "function"
        ? nextFilters(prevFilters)
        : nextFilters,
    );
  };
  const columnsRender = buildColumnsWithHeaderFilters(
    [
      ...decorateEditableColumns(columns, {
        editIndex,
        getDataSource: () => dataSource,
        normalizeValue: (value, dataIndex) =>
          dataIndex === "vehicleList"
            ? parseVehicleListTags(value)
            : typeof value == "string"
              ? value.toUpperCase()
              : value,
        onUpdate: (dataIndex, value, rowId) =>
          handleUpdateRow(dataIndex, value, rowId),
      }),
      {
        title: "",
        key: "action",
        width: 60,
        fixed: "right",
        render: (_: any, record: any, index: number) =>
          editIndex.find((ind: any) => ind.index === _._id) ? (
            <div>
              <Button
                loading={isLocked(`contractor:${_._id}`)}
                disabled={isLocked(`contractor:${_._id}`)}
                onClick={() => {
                  handleActionSave(_._id, index);
                }}
              >
                Lưu
              </Button>{" "}
              <Button
                disabled={isLocked(`contractor:${_._id}`)}
                onClick={() => {
                  handleActionCancel(_._id);
                }}
              >
                Hủy
              </Button>
            </div>
          ) : (
            <TableActionButtons
              items={[
                {
                  key: "create",
                  label: "Thêm mới",
                  icon: <PlusCircleOutlined />,
                  tone: "info",
                  hidden: Boolean(record.parent),
                  disabled: !checkPermissions("CONTRUCTOR", "add", features),
                  onClick: () => handleActionTable("create", record, _._id),
                },
                {
                  key: "edit",
                  label: "Chỉnh sửa",
                  icon: <EditFilled />,
                  tone: "edit",
                  disabled: !checkPermissions("CONTRUCTOR", "edit", features),
                  onClick: () => handleActionTable("edit", record, _._id),
                },
                {
                  key: "delete",
                  label: "Xoá",
                  icon: <DeleteOutlined />,
                  tone: "delete",
                  danger: true,
                  disabled: !checkPermissions("CONTRUCTOR", "delete", features),
                  onClick: () => handleActionTable("delete", record, _._id),
                },
              ]}
            />
          ),
      },
    ],
    filters,
    handleSetFilters,
  );
  const updateTreeNode = (
    tree: any[],
    targetId: string,
    newData: any,
  ): any[] => {
    return tree.map((node) => {
      // nếu đúng node cần update
      if (node._id === targetId) {
        return {
          ...node,
          ...newData,
        };
      }
      // nếu có children thì duyệt tiếp
      if (node.children && node.children.length > 0) {
        return {
          ...node,
          children: updateTreeNode(node.children, targetId, newData),
        };
      }
      return node;
    });
  };
  const removeTreeNode = (tree: any[], targetIds: string[]): any[] => {
    const idSet = new Set(targetIds);
    const removeRecursive = (nodes: any[]): any[] => {
      return nodes
        .filter((node) => !idSet.has(node._id))
        .map((node) => {
          if (node.children?.length) {
            return {
              ...node,
              children: removeRecursive(node.children),
            };
          }
          return node;
        });
    };
    return removeRecursive(tree);
  };
  // Function to handle action
  const handleActionTable = (action: string, record: any, index: number) => {
    switch (action) {
      case "create":
        handleAddRow(record._id, record);
        break;
      case "edit":
        setEditIndex([
          ...editIndex,
          {
            index: index,
            record: {
              ...record,
              // settleAgreement:
              //   record.settleAgreement ?? DEFAULT_SETTLE_AGREEMENT,
            },
          },
        ]);
        break;
      case "delete":
        confirm({
          title: "Xác nhận xoá",
          content: "Bạn có chắc chắn muốn xoá bản ghi này không?",
          okText: "Xoá",
          cancelText: "Huỷ",
          okType: "danger",
          onOk() {
            TruckVendorApi.deleteTruckVendor(record._id)
              .then((res) => {
                const newTreeData = removeTreeNode(dataSource, [record._id]);
                setDataSource(newTreeData);
                // // đồng thời xoá khỏi editIndex nếu đang edit
                setEditIndex((prev: any[]) =>
                  prev.filter((item) => item.index !== index),
                );
              })
              .catch();
          },
          onCancel() {},
        });
        // tìm index trong data theo id
        break;
      default:
        break;
    }
    // setEditIndex([...editIndex, { index: index, record: record }]);
  };
  const handleUpdateRow = (key: string, value: any, index: number) => {
    const newEdit = [...editIndex];
    const findInd = newEdit.findIndex((item: any) => item.index === index);
    if (findInd === -1) return;
    const row = { ...newEdit[findInd] };
    const record = { ...(row.record || {}) };
    record[key] = value;
    // ✅ đánh dấu touched
    row.touchedFields = { ...(row.touchedFields || {}), [key]: true };
    row.record = record;
    newEdit[findInd] = row;
    setEditIndex(newEdit);
  };
  const handleActionSave = async (index: any, key: number) => {
    await runLocked(`contractor:${index}`, async () => {
      try {
        const newData: any = [...dataSource];
        let res: any = null;
        const rowEdit = editIndex.find((ind: any) => ind.index === index)?.record;
        if (!rowEdit) {
          messageApi.error("Không tìm thấy dữ liệu cần lưu");
          return;
        }
        // ✅ check NULL các field req
        if (hasNullRequiredField(rowEdit, REQUIRED_FIELDS)) {
          messageApi.error("Không được bỏ trống bất kỳ trường bắt buộc nào");
          return;
        }
        const isNew = rowEdit.status === "new";
        // payload đúng shape API
        const payload = {
          code: rowEdit.code,
          name: rowEdit.name,
          shortName: rowEdit.shortName,
          phoneNumber: rowEdit.phoneNumber,
          hotline: rowEdit.hotline,
          address: rowEdit.address,
          taxNumber: rowEdit.taxNumber,
          // settleAgreement: rowEdit.settleAgreement ?? DEFAULT_SETTLE_AGREEMENT,
          state: rowEdit.state,
          vehicleList: rowEdit.vehicleList ?? [],
          parent: rowEdit.parent,
        };
        // ===== CALL API =====
        if (isNew) {
          res = await TruckVendorApi.postCreateTruckVendor(payload);
          if (res.success) {
            delete rowEdit.status;
            rowEdit._id = res?._id;
          }
        } else {
          res = await TruckVendorApi.putUpdateTruckVendor(payload, index);
        }
        // ===== CHỈ KHI API OK =====
        if (res.success) {
          const newTreeData = updateTreeNode(newData, index, rowEdit);
          setDataSource(newTreeData);
          setEditIndex((prev: any[]) =>
            prev.filter((ind: any) => ind.index !== index),
          );
        }
      } catch (err: any) {
        messageApi.error(err?.message || "Lưu thất bại");
      }
    });
  };
  const handleActionCancel = (index: number) => {
    const editItem = editIndex.find((ind: any) => ind.index === index);
    if (editItem?.record?.status) {
      setDataSource((prev: any) => prev.filter((_: any) => _._id !== index));
    }
    const newEdit = editIndex.filter((ind: any) => ind.index !== index);
    setEditIndex(newEdit);
  };
  const handleAddRow = (parent?: string, record?: any) => {
    const newObjCreate = parent
      ? {
          ...newObj,
          status: "new",
          _id: `create-${Date.now()}`,
          parent: parent,
        }
      : {
          ...newObj,
          status: "new",
          _id: `create-${Date.now()}`,
        };
    if (parent && record) {
      const newTreeData = [...dataSource];
      const newIndexNode = newTreeData.findIndex((ite) => ite._id === parent);
      newTreeData[newIndexNode] = {
        ...record,
        children: [...record.children, newObjCreate],
      };
      setDataSource(newTreeData);
    } else {
      setDataSource([newObjCreate, ...dataSource]);
    }
    setEditIndex([
      ...editIndex,
      { index: newObjCreate._id, record: newObjCreate },
    ]);
  };
  const handleOnShortDeleted = () => {
    confirm({
      title: "Xác nhận xoá",
      content: `Bạn có chắc chắn muốn xoá ${selectedRowKeys.length} bản ghi đã chọn không?`,
      okText: "Xoá",
      cancelText: "Huỷ",
      okType: "danger",
      onOk() {
        // Call API xoá nhiều
        // shortDeleteRouterBase({ ids: selectedRowKeys as string[] })
        //   .then(() => {
        const newTreeData = removeTreeNode(dataSource, selectedRowKeys);
        setDataSource(newTreeData);
        setSelectedRowKeys([]);
        // })
        // .catch((error) => {
        //   messageApi.error(
        //     error?.message || "Xoá bản ghi thất bại, vui lòng thử lại",
        //   );
        // });
      },
      onCancel() {
        setSelectedRowKeys([]);
      },
    });
  };
  const handleOnChangePosition = (
    dataIndex: string,
    value: boolean | "left" | "right",
    type: "hidden" | "fixed",
  ) => {
    setColumns(updateColumnDisplayState(columns, dataIndex, value, type));
  };
  // Function to render
  const renderModalPosition = () => {
    return (
      <Modal
        open={onModalPostion}
        className={styles.Modal}
        width={"70%"}
        onCancel={() => {
          setOnModalPosition(false);
        }}
        title="Hiển thị cột"
        bodyProps={{
          className: styles.ModalBody,
        }}
        footer={false}
      >
        <Row>
          <Col span={16}>Tên cột</Col>
          <Col span={4}>Hiển thị</Col>
          <Col span={4}>Cố định(trái, phải)</Col>
        </Row>
        <Divider />
        {columns
          .filter((it: any, index) => index !== 0)
          ?.map((col: any, key: number) => {
            return (
              <div key={key}>
                <Row>
                  <Col span={16}>{col.title}</Col>
                  <Col span={4}>
                    <Checkbox
                      checked={!col.hidden}
                      onChange={(e) => {
                        handleOnChangePosition(
                          col.dataIndex,
                          e.target.checked,
                          "hidden",
                        );
                      }}
                    />
                  </Col>
                  <Col span={4}>
                    <Checkbox
                      checked={col.fixed === "left" ? true : false}
                      onChange={(e) => {
                        handleOnChangePosition(
                          col.dataIndex,
                          e.target.checked && "left",
                          "fixed",
                        );
                      }}
                      style={{ marginRight: "20px" }}
                    />
                    <Checkbox
                      checked={col.fixed === "right" ? true : false}
                      onChange={(e) => {
                        handleOnChangePosition(
                          col.dataIndex,
                          e.target.checked && "right",
                          "fixed",
                        );
                      }}
                    />
                  </Col>
                </Row>
                <Divider />
              </div>
            );
          })}
      </Modal>
    );
  };
  // Function to effect
  useEffect(() => {
    let mounted = true;
    setLoading(true);
    const getAllKeys = (rows: any[] = []): React.Key[] => {
      let keys: React.Key[] = [];
      for (const row of rows) {
        if (row?._id) {
          keys.push(String(row._id));
        }
        if (row?.children?.length) {
          keys = [...keys, ...getAllKeys(row.children)];
        }
      }
      return keys;
    };
    const fetchData = async () => {
      const res = await TruckVendorApi.getAllTruckVendor({
        pageSize: pagination.pageSize,
        current: pagination.current,
        ...filters,
      });
      if (mounted && features) {
        setExpandedRowKeys(getAllKeys(res?.data ?? []));
        setDataSource(res?.data ?? []);
        setPagination((prev) => ({
          ...prev,
          total: res?.totalItem || 0,
        }));
        setLoading(false);
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, [filters, features, pagination.current, pagination.pageSize]);
  // Main render
  return (
    <PermissionDirect screen={["CONTRUCTOR"]}>
      <div className={styles.Contructor}>
        {contextHolder}
        <div className="container">
          <HeaderTable
            title="Danh sách nhà xe"
            buttons={[
              // {
              //   children: "Mẫu import",
              //   icon: <img src="/icon/xlsx.svg" />,
              //   onClick: () => {
              //     CommonApi.getDownloadTemplate("truckVendor",);
              //   },
              //   type: "primary",
              // },
              {
                children: "Cài đặt hiển thị",
                icon: <Setting />,
                onClick: () => {
                  setOnModalPosition(true);
                },
                type: "primary",
              },
              // {
              //   children: "Import",
              //   icon: <img src="/icon/xlsx.svg" />,
              //   onClick: () => {
              //     setOpenModalImportSalary(true);
              //   },
              //   style: {
              //     backgroundColor: checkPermissions(
              //       "FIXED_ROUTE_SALARY",
              //       "import",
              //       features,
              //     )
              //       ? "#00529F"
              //       : "#C0C0C0",
              //   },
              //   disabled: !checkPermissions(
              //     "FIXED_ROUTE_SALARY",
              //     "import",
              //     features,
              //   ),
              // },
              // {
              //   children: "Thêm mới",
              //   icon: <PlusIcon />,
              //   onClick: handleAddRow,
              //   style: {
              //     backgroundColor:
              //       (activeTabs === "2" &&
              //         checkPermissions("FIXED_ROUTE_SALARY", "add", features)) ||
              //       (activeTabs === "1" &&
              //         checkPermissions("ROUTE_BASE", "add", features))
              //         ? "#0076E3"
              //         : "#C0C0C0",
              //   },
              //   disabled:
              //     activeTabs === "1"
              //       ? !checkPermissions("ROUTE_BASE", "add", features)
              //       : activeTabs === "2" &&
              //         !checkPermissions("FIXED_ROUTE_SALARY", "add", features),
              // },
            ]}
          />
          <div
            style={{
              width: "100%",
              overflowX: "auto",
            }}
          >
            {selectedRowKeys.length > 0 && (
              <Button
                danger
                type="primary"
                onClick={handleOnShortDeleted}
                disabled={!checkPermissions("ROUTE_BASE", "delete", features)}
              >
                Xoá
              </Button>
            )}
            <Table
              loading={loading}
              size="small"
              dataSource={dataSource}
              columns={columnsRender}
              pagination={false}
              rowKey={(record: any) => String(record._id)}
              scroll={{ x: "max-content" }}
              style={{ width: "100%" }} // Full theo container
              expandable={{
                expandedRowKeys,
                expandIcon: () => null,
              }}
              // rowSelection={{
              //   selectedRowKeys: selectedRowKeys,
              //   onChange: (selectedKeys) => {
              //     setSelectedRowKeys(selectedKeys);
              //   },
              // }}
              bordered={true}
            />
          </div>
          <Button
            className={styles.ButtonPlus}
            icon={<PlusIcon />}
            onClick={() => {
              handleAddRow();
            }}
            disabled={!checkPermissions("CONTRUCTOR", "add", features)}
          >
            Thêm mới
          </Button>
          <Pagination
            total={pagination.total}
            current={pagination.current}
            pageSize={pagination.pageSize}
            onChange={(page, pageSize) => {
              setPagination((prev) => ({
                ...prev,
                current: page,
                pageSize: pageSize || prev.pageSize,
              }));
            }}
            showSizeChanger
            align="end"
            className={styles.Pagination}
          />
        </div>
        {renderModalPosition()}
      </div>
    </PermissionDirect>
  );
};
export { Contructor };
